import React from "react";
import { CheckCircle } from "lucide-react";
import subscription from "../../assets/Img_3.png";
import { Link } from 'react-router-dom';

const AboutBenefit = () => {
  const points = [
    "Timed/Untimed Practice Tests",
    "Test in each practice area to know strengths and areas of focus.",
    "Results are shared immediately after each test completion",
    "Unlimited re-sits",
    "Weekly Tests to gauge the progress",
    "Get clear, data-driven insights that show exactly where support is needed, empowering you to guide success and confidence",
  ];

  const isLoggedIn = !!localStorage.getItem("access_token");

  return (
    <div className="bg-gradient-to-br from-teal-50 to-yellow-80 py-10 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 md:gap-16">

          {/* Left Content */}
          <div className="w-full lg:w-1/2">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-black mb-4 md:mb-6 leading-tight md:leading-snug">
              Benefits of <span className="text-purple-700">ExamWarrior</span> Community for Exam Preparation
            </h2>
            <ul className="space-y-3 md:space-y-5 text-base md:text-lg text-[#0F766E] font-medium">
              {points.map((point, index) => (
                <li key={index} className="flex items-start gap-2 md:gap-3">
                  <CheckCircle className="text-yellow-600 w-4 h-4 md:w-5 md:h-5 mt-0.5 md:mt-1 flex-shrink-0 animate-pulse" />
                  <span className="leading-snug md:leading-relaxed">{point}</span>
                </li>
              ))}
            </ul>
            {!isLoggedIn && (
              <div className="mt-6 md:mt-10">
                <Link to="/signup">
                  <button className="px-4 py-2 md:px-6 md:py-3 bg-gradient-to-r from-purple-600 via-blue-500 to-teal-400 text-white font-semibold rounded-full shadow-md md:shadow-xl hover:brightness-110 transition duration-300 text-sm md:text-lg flex items-center">
                    Create Your Account
                    <i className="fas fa-arrow-right ml-1 md:ml-2"></i>
                  </button>
                </Link>
              </div>
            )}
          </div>

          {/* Right Image - Reduced spacing on mobile */}
          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end -my-2 md:my-0 md:pl-0 lg:pl-12">
            <img
              src={subscription}
              alt="Progress Report Mockup"
              className="w-full max-w-[500px] md:max-w-[900px] object-contain"
            />
          </div>

        </div>
      </div>
    </div>
  );
};

export default AboutBenefit;